import React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { MuiThemeProvider, unstable_createMuiStrictModeTheme as createMuiTheme } from '@material-ui/core/styles';
import { Redirect, Route, Switch } from 'react-router';
import {
  BrowserRouter as Router,
} from 'react-router-dom';
import { UserProvider } from './contexts/UserContext';
import { VendingMachineProvider } from './contexts/VendingMachineContext';
import './App.css';
import LoginView from './views/LoginView';
import RegisterView from './views/RegisterView';
import LanguagesView from './views/LanguagesView';
import ProfileView from './views/ProfileView';
import ChangePasswordView from './views/ChangePasswordView';
import ProductListView from './views/ProductListView';
import PaymentMethodView from './views/PaymentMethodView';
import { SessionProvider } from './contexts/SessionContext';
import PurchasesHistoryView from './views/PurchasesHistoryView';
import LoadVendingMachineInfo from './components/LoadVendingMachineInfo';
import ProductSelectionView from './views/ProductSelectionView';
import MandateRequestView from './views/MandateRequestView';
import MandateResultView from './views/MandateResultView';
import ResetPasswordForm from './components/forms/ResetPasswordForm';
import MBWayMobilePhone from './views/MBWayMobilePhone';
import ActivateAccount from './views/ActivateAccount';
import SessionDocumentsView from './views/SessionDocumentsView';
import RevalueSession from './views/RevalueSession';
import RevalueSelection from './views/RevalueSelection';
import VMView from './views/VMView';
import NoVMView from './views/NoVMView';
import ReadQR from './views/ReadQR';
import { IconContextProvider } from './contexts/IconContext';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import DocumentSearchView from './views/DocumentSearchView';
import { GlobalStyles } from './styles';
// import LogViewer from './views/LogViewer';
import HelexiaFooter from './components/HelexiaFooter';
import SPGCard from './components/SPGCard';

const muiTheme = createMuiTheme({
  palette: {
    primary: { main: 'rgb(40, 40, 40)' },
    secondary: { main: 'rgb(255,255,255)' },
  },
});

const AppContent = () => {
  const { theme: currentTheme } = useTheme();

  return (
    <StyledThemeProvider theme={currentTheme}>
      <GlobalStyles />
      <IconContextProvider>
        <VendingMachineProvider>
          <UserProvider>
            <SessionProvider>
              <Router>
                <Switch>
                  <Route exact path="/" component={LoginView} />
                  <Route path="/register" component={RegisterView} />
                  <Route path="/languages" component={LanguagesView} />
                  <Route path="/profile" component={ProfileView} />
                  <Route path="/password-change" component={ChangePasswordView} />
                  <Route path="/home" component={VMView} />
                  <Route path="/products" component={ProductListView} />
                  <Route path="/payment-method-selection" component={PaymentMethodView} />
                  <Route path="/home-no-vm" component={NoVMView} />
                  <Route path="/history-no-vm" component={PurchasesHistoryView} />
                  <Route path="/history-vm" component={(props) => <PurchasesHistoryView vm {...props} />} />
                  <Route path="/product-selection" component={ProductSelectionView} />
                  <Route path="/mandate" component={MandateRequestView} />
                  <Route path="/mandate-result" component={MandateResultView} />
                  <Route path="/mbway" component={MBWayMobilePhone} />
                  <Route path="/spgcard" component={SPGCard} />
                  <Route path="/load" component={LoadVendingMachineInfo} />
                  <Route path="/password-recovery" component={ResetPasswordForm} />
                  <Route path="/activate" component={ActivateAccount} />
                  <Route path="/session/documents/:id" component={SessionDocumentsView} />
                  <Route path="/session/documents" component={DocumentSearchView} />
                  <Route path="/revalue-session" component={RevalueSession} />
                  <Route path="/revalue-amount-selection" component={RevalueSelection} />
                  {/* Kept for QR stickers already in the field; connector selection now lives in /home */}
                  <Route
                    path="/select-socket"
                    render={({ location }) => <Redirect to={{ pathname: '/home', search: location.search }} />}
                  />
                  <Route path="/readQr" component={ReadQR} />
                </Switch>
                <HelexiaFooter />
              </Router>
            </SessionProvider>
          </UserProvider>
        </VendingMachineProvider>
      </IconContextProvider>
    </StyledThemeProvider>
  );
};

const App = () => (
  <MuiThemeProvider theme={muiTheme}>
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  </MuiThemeProvider>
);
export default App;
